import Swiper from 'swiper/bundle'
import YTPlayer from 'yt-player'
import inView from 'in-view'

const shopInit = () => {
  if (!document.querySelector('.shop-single')) return

  shopSlideInit()
  shopFvMovie()
  pwaBanner()
}

/**
 * slider init
 */
const shopSlideInit = () => {
  if (document.querySelector('[data-shop-fv-slider]')) {
    const shopFvSlider = new Swiper('[data-shop-fv-slider]', {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: false,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.shop-fv__slider-next',
        prevEl: '.shop-fv__slider-prev',
      },
    })
    const isTableLandscape = window.matchMedia('(min-width: 1024px)')

    const setImgHeightTableLandscape = () => {
      const setHeight = isTableLandscape.matches
        ? document.querySelector('.shop-fv__info').clientHeight
        : 0

      Array.from(document.querySelectorAll('.shop-fv__slide-img')).forEach((item) => {
        item.style.minHeight = setHeight > 0 ? `${setHeight}px` : 'auto'
      })
    }

    window.addEventListener('load', setImgHeightTableLandscape)
    window.addEventListener('scroll', setImgHeightTableLandscape)
    window.addEventListener('resize', setImgHeightTableLandscape)
  }

  if (document.querySelector('[data-shop-topics-slider]')) {
    const shopTopicsSlide = new Swiper('[data-shop-topics-slider]', {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
      },
      speed: 500,
      loop: true,
      effect: 'fade',
      allowTouchMove: true,
      navigation: {
        nextEl: '.shop-fv__topics-next',
        prevEl: '.shop-fv__topics-prev',
      },
    })
  }

  if (document.querySelector('[data-shop-info-slider]')) {
    const shopInfoThumb = new Swiper('[data-shop-info-thumb]', {
      slidesPerView: 4,
      spaceBetween: 0,
      autoplay: false,
      centeredSlides: false,
      watchSlidesProgress: true,
    })

    const shopInfoSlide = new Swiper('[data-shop-info-slider]', {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: false,
      centeredSlides: true,
      autoHeight: true,
      thumbs: {
        swiper: shopInfoThumb,
      },
    })
  }

  if (document.querySelector('[data-shop-service-slider]')) {
    const shopServiceSlider = new Swiper('[data-shop-service-slider]', {
      slidesPerView: 1.6,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
      speed: 500,
      loop: true,
      allowTouchMove: true,
      navigation: {
        nextEl: '.shop-service__slider-next',
        prevEl: '.shop-service__slider-prev',
      },
      breakpoints: {
        768: {
          spaceBetween: 15,
          slidesPerView: 2.5,
          centeredSlides: false,
        },
        1024: {
          spaceBetween: 15,
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    })
    shopServiceSlider.autoplay.stop()

    inView('[data-shop-service-slider]').on('enter', (el) => {
      shopServiceSlider.autoplay.start()
    })
  }

  if (document.querySelector('[data-shop-recommend-slider]')) {
    const shopRecommendSlider = new Swiper('[data-shop-recommend-slider]', {
      slidesPerView: 1.6,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
      speed: 500,
      loop: true,
      allowTouchMove: true,
      navigation: {
        nextEl: '.shop-recommend__slider-next',
        prevEl: '.shop-recommend__slider-prev',
      },
      breakpoints: {
        768: {
          spaceBetween: 15,
          slidesPerView: 2.5,
          centeredSlides: false,
        },
        1024: {
          spaceBetween: 15,
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    })
    shopRecommendSlider.autoplay.stop()

    inView('[data-shop-recommend-slider]').on('enter', (el) => {
      shopRecommendSlider.autoplay.start()
    })
  }

  if (document.querySelector('[data-shop-pickup-slider]')) {
    const shopPickupSlider = new Swiper('[data-shop-pickup-slider]', {
      slidesPerView: 1.6,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
      speed: 500,
      loop: true,
      allowTouchMove: true,
      navigation: {
        nextEl: '.shop-pickup__slider-next',
        prevEl: '.shop-pickup__slider-prev',
      },
      breakpoints: {
        768: {
          spaceBetween: 15,
          slidesPerView: 2.5,
          centeredSlides: false,
        },
        1024: {
          spaceBetween: 15,
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    })
    shopPickupSlider.autoplay.stop()

    inView('[data-shop-pickup-slider]').on('enter', (el) => {
      shopPickupSlider.autoplay.start()
    })
  }
}

const shopFvMovie = () => {
  const fvMovie = document.querySelector('[data-fv-shop-move]')

  if (!fvMovie) return

  const thumbnail = document.querySelector('[data-fv-shop-move] > span')

  /*
   * 動画サイズを画面にフィットさせる
   */
  const screen_fit = () => {
    const { clientWidth, clientHeight } = document.querySelector('.shop-fv__movie')
    const screen_switch = 0.5625
    const screen_ratio = clientHeight / clientWidth
    const ratio_H = clientHeight / screen_switch
    const ytPlayer = document.querySelector('#shop-fv__movie-frame')
    ytPlayer.style.height = 'auto'
    ytPlayer.style.width = screen_ratio > screen_switch ? `${ratio_H}px` : '100%'
  }

  screen_fit()

  /*
   * 動画を再生する
   */
  const player = new YTPlayer('#shop-fv__movie-frame', {
    controls: false,
  })
  player.load(fvMovie.getAttribute('data-fv-shop-move'), true)
  player.mute()
  player.on('ended', () => {
    player.play()
  })
  player.on('playing', () => {
    screen_fit()
    setTimeout(() => {
      thumbnail.classList.add('is-playing')
    }, 3000)
  })

  window.addEventListener('resize', (e) => {
    e.preventDefault()
    screen_fit()
  })
}

const pwaBanner = () => {
  const body = document.querySelector('body')
  const pwaBanner = document.querySelector('.shop-push-banner')
  if (pwaBanner && !window.matchMedia('(display-mode: standalone)').matches) {
    // 一度だけ表示する
    if (localStorage.getItem('pwaBanner') !== 'true') {
      body.classList.add('view-pwa-banner')
    }
  }

  const pwaBannerLink = document.querySelector('.shop-push-banner a')
  if (pwaBannerLink) {
    pwaBannerLink.addEventListener('click', () => {
      localStorage.setItem('pwaBanner', 'true')
    })
  }

  const pwaCloser = document.querySelector('.shop-push-banner__close')
  if (pwaCloser) {
    pwaCloser.addEventListener('click', () => {
      body.classList.remove('view-pwa-banner')
      localStorage.setItem('pwaBanner', 'true')
    })
  }
}

export { shopInit }
